export default __webpack_public_path__ + "static/media/fallback-user.d6a1bae9.png";